import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getTim = createAsyncThunk(
    "tim/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getTim",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    data: [],
    isTimFetching: false,
    isTimSuccess: false,
    isTimError: false,
};

export const timSlice = createSlice({
    name: "tim",
    initialState,
    reducers: {},
    extraReducers: {
        [getTim.fulfilled]: (state, {payload}) => {
            state.isTimFetching = false;
            state.isTimSuccess = true;
            state.message = payload.message;
            state.data = payload.data;
            return state;
        },
        [getTim.rejected]: (state, {payload}) => {
            state.isTimFetching = false;
            state.isTimError = true;
            state.errorMessage = payload.message;
        },
        [getTim.pending]: (state) => {
            state.isTimFetching = true;
        },
    },
});

export const timSelector = (state) => state.tim;
